import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Oval } from 'react-loader-spinner';
import styled from 'styled-components';

const Center = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BusinessProtectedRoute = ({ children }) => {
  const { user, initializing } = useAuth();
  const location = useLocation();

  if (initializing) {
    return (
      <Center>
        <Oval height={40} width={40} color="#2E8B57" secondaryColor="#CDEAD7" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/business/login" replace state={{ from: location }} />;
  }

  return children;
};

export default BusinessProtectedRoute;
